import React, { useCallback, useEffect, useState } from 'react';
import { useActivate } from 'react-activation';
import { useHistory, useLocation } from 'react-router-dom';
import useLoginStatus from '../../utils/hooks/useLoginStatus';
import CommentOn from '../CommentOn';
import MyComt from '../CommentOn/MyComt';
import styles from './Comment.module.less';
import config from './config';
import List from './List/index';
import Score from './Score';
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);
export default ({
  data,
  scrollEl,
  hasCommentOn = true,
  updateCommentData = null,
  forum,
  commentTargetInfo,
  handleReleaseInfo = () => {},
  afferentShow = false,
  controlAfferentShow = () => {},
  transmissionScore,
  emptyIsOpen,
  isScoreEmpty = false,
}) => {
  const [info, setInfo] = useState(null);
  const [addCommentInfo, setAddCommentInfo] = useState(null);
  const [comtUpdate, setComtUpdate] = useState(true);
  const history = useHistory();
  const location = useLocation();
  const loginStatus = useLoginStatus();
  const logInfo = useSelector(selectLogInfo);
  const dispatch = useDispatch();
  const getCommentInfo = useCallback(async () => {
    try {
      const res = await config.getCommentInfo({
        type: data.type,
        tagCode: data.tagCode,
        bizIdentity: data.bizIdentity,
      });
      setInfo(res);
      handleReleaseInfo(res);
      if (res.commentContent.id) {
        if (location?.search && afferentShow === true) {
          setComtUpdate(true);
        } else {
          setComtUpdate(false);
        }
      }
    } catch (err) {
      //
    }
  }, []);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(async () => {
    getCommentInfo();
  }, [loginStatus, afferentShow]);

  useActivate(() => {
    if (history.action === 'PUSH') {
      getCommentInfo();
    }
  });

  useEffect(() => {
    if (updateCommentData) {
      setAddCommentInfo(updateCommentData);
    }
  }, [updateCommentData]);

  // useEffect(() => {
  //   if (!comtUpdate && info.commentContent && transmissionScore) {
  //     setControlScore(1);
  //   }
  //   // if (!comtUpdate && !controlScore) {
  //   //   setControlScore(null);
  //   // }
  // }, [info, comtUpdate, controlScore]);

  if (!info) {
    return null;
  }

  return (
    <div className={styles.comment} id="soft_detail_comment">
      {//  1.评分 2.标签
      info?.funcs?.indexOf('1') > -1 && <Score data={info} />}
      {hasCommentOn && (
        <div className={styles.comment_editor} id="soft_detail_comment_info">
          {!comtUpdate && info.commentContent ? (
            <MyComt
              releaseInfo={info}
              onUpdate={() => {
                setComtUpdate(true);
              }}
              // emptyIsOpen={() => setControlScore(null)}
            />
          ) : (
            <CommentOn
              requestInfo={data}
              releaseInfo={{
                ...(info || {}),
              }}
              handleUpdate={data => {
                if (data) {
                  setComtUpdate(false);
                  setAddCommentInfo(data);
                  setInfo({
                    ...info,
                    commentContent: data,
                    commentUserNum: info.commentContent
                      ? info.commentUserNum
                      : (info.commentUserNum || 0) + 1,
                    commentNum: info.commentContent ? info.commentNum : (info.commentNum || 0) + 1,
                  });
                } else {
                  setComtUpdate(false);
                }
              }}
              hasScore={info?.funcs?.indexOf('1') > -1}
              commentTargetInfo={commentTargetInfo}
              placeHolder="已经用了一段时间了吧，写出您的使用心得，分享给更多网友..."
              tScore={transmissionScore}
              empty={() => emptyIsOpen()}
              isScoreEmpty={isScoreEmpty}
            />
          )}
        </div>
      )}

      <div className={styles.comment_list}>
        <List
          data={{ ...info, ...data }}
          requestInfo={data}
          releaseInfo={info}
          scrollEl={scrollEl}
          addCommentInfo={addCommentInfo}
          forum={forum}
          handleUpdateRelase={getCommentInfo}
          commentTargetInfo={commentTargetInfo}
        />
      </div>
    </div>
  );
};
